import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SquirrelTabs, TENANTTABS } from 'shared';
import { TenantDto, TenantResolved } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'edit-tenant',
    templateUrl: './edit-tenant.component.html',
    styleUrls: ['./edit-tenant.component.scss'],
    standalone: false
})
export class EditTenantComponent implements OnInit {

  tabs: SquirrelTabs[] = [];
  pageTitle!:string;

  tenantDto!:TenantDto;

  constructor(private route: ActivatedRoute,
    private oauthService: OAuthServiceService,
    public translate:TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    //this.tabs = TENANTTABS;
    console.log("-------------> routeData = :", this.route.data)
    this.route.data.subscribe((data: any) => {
      console.log("-------------> routeDataAny = :", data)
      const resolvedData: TenantResolved = data['resolvedData'];
      this.tenantDto = resolvedData.tenantDto;
      this.pageTitle = "Mandant " + resolvedData.tenantDto.displayName
    },
    // error
    );
  }
}
